import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { ApiResponseInterface, SelectOptionsInterface } from '../../interfaces/common.interface';
import { SelectSearchComponent } from '../select-search/select-search.component';
import { NavigationEnd, Router } from '@angular/router';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-state-search',
  templateUrl: '../select-search/select-search.component.html',
})

/**
 *
 */
export class StateSearchComponent extends SelectSearchComponent {
  @Input() countryCode: number | undefined;
  @Input() clearSelected!: string;
  @Input() override label!: string;
  @Input() override enableError!: boolean;
  @Input() defaultSelected: any;
  @Output() override optionChangeEmitter = new EventEmitter<SelectOptionsInterface>();
  private visitedCountries: any = {};
  @Input() override initialPlaceholder!: string;


  /**
   * @constructor
   */
  constructor(
    private commonServices: CommonService,
    public override _eref: ElementRef,protected override router : Router
  ) {
    super(_eref,router);
  }

  /**
   * called initially
   */
  override ngOnInit(): void {
     this.router.events.subscribe((event) => {
              if (event instanceof NavigationEnd) {
               setTimeout(() => {  initFlowbite();})
              }
            });
    // this.initialPlaceholder = 'Select your State ';
    this.placeholder = 'Search your State here';
    this.items = [];
    this.showSearchBox = true;
  }

  /**
   * triggered when changes occur
   *
   * @param {SimpleChanges} simpleChanges
   */
  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges?.countryCode?.currentValue) {
      const tempCountryCode = simpleChanges?.countryCode?.currentValue || this.countryCode;
      this.getStatesBasedOnCountry(tempCountryCode);
    }
    if (simpleChanges?.defaultSelected?.previousValue || simpleChanges?.defaultSelected?.currentValue) {
      this.clearSelectedOption();
      const value = simpleChanges?.countryCode?.currentValue ? simpleChanges?.countryCode?.currentValue:simpleChanges?.defaultSelected?.previousValue
    }
  }

  /**
   * check for cached value for state list
   *
   * @param {any} countryCode
   * @param {any} stateCode
   */
  private checkCachedValueStateList(countryCode: any, stateCode: any): void {
    if (!this.visitedCountries[countryCode]) {
      this.getStatesBasedOnCountry(countryCode);
    }
    if (stateCode) {
      this.items = this.visitedCountries[countryCode];
      this.onSelectPreProcess(stateCode);
    }
  }

  /**
   * Get State based on country id
   *
   * @param {number} countryId
   */
  public getStatesBasedOnCountry(countryId: number): void {
    if (!countryId) return;
    this.loader = true;
    this.commonServices.getStates(countryId.toString()).subscribe({
      next: (response: ApiResponseInterface) => {        
        this.loader = false;
         // Extract only the 'name' values from response.data
         const stateNames = (response?.data || []).map((state: any) => ({
          name: state.name,
          id: state.id,
          _id: state._id
        }));
  

      // Pass the array of names to stateListFormatter
        this.stateListFormatter(stateNames, countryId);
      },
      error: () => {
        this.loader = false;
      }
    }
    );
  }

  /**
   * State list formatter
   *
   * @param {Array<any>} list
   * @param {number} countryId
   */
  private stateListFormatter(list: Array<any>, countryId: number): void {
    const formattedCountryList: Array<SelectOptionsInterface> = [];
    list.forEach((data) => {
      formattedCountryList.push({ displayText: data.name, value: data.name, _id: data._id, id: data?.id });
    });
    this.items = formattedCountryList;
    this.filteredItems = this.items;
    this.visitedCountries[countryId] = [...formattedCountryList];
    // Ensure defaultSelected is valid and matches the list
    const isValidDefault = formattedCountryList.some(
      (item) => item.value === this.defaultSelected
    );
  if (!isValidDefault && formattedCountryList.length > 0) {
    // If no valid default is set, use the first item as default
    this.defaultSelected = formattedCountryList[0].value;
  }

    // Select state of the defaultSelected value is available
    if (this.defaultSelected) {
      this.onSelectPreProcess(this.defaultSelected);
    }
  }

  /**
   * listen for options changes
   *
   * @param {string} selectedCountry
   */
  public optionChangeListener(selectedCountry: SelectOptionsInterface): void {
    this.optionChangeEmitter.emit(selectedCountry);
  }

  /**
   * On select change
   *
   * @param {string} value
   */
  public override onSelectChange(value: string): void {
    super.onSelectPreProcess(value);
    this.optionChangeListener(this.selectedOption);
  }

}
